module.exports = __webpack_public_path__ + "static/img/200089.c220fa96.png";